<script>

  import PageContent from '@/components/PageContent'
  import { HeadMeta } from '@/utils/head-meta'

  export default {
    components: {
      PageContent
    },
    scrollToTop: true,
    async asyncData ({ app, params, error }) {
      try {
        const { items } = await app.$contentful.getEntries({
          content_type: 'page',
          'fields.slug': params.childSlug,
          include: 4
        })
        const currentChildPage = items.filter(item => (item.fields.parentPage && !item.fields.parentPage.fields.parentPage && item.fields.parentPage.fields.slug === params.slug))
        if (!items.length || !currentChildPage[0] || currentChildPage.length > 1) error({ statusCode: 404, message: 'This page could not be found' })
        return {
          page: currentChildPage[0]
        }
      } catch (e) {
        error(e)
      }
    },
    head () {
      return HeadMeta(this.page.fields)
    }
  }
</script>

<template>
  <page-content :page="page" />
</template>
